import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { trackingSearchSchema } from '@/entities/tracking';
import { DispatchPage } from '@/pages/dispatch';

export const Route = createFileRoute('/dispatch')({
  staticData: { permission: 'dispatch.view' },
  validateSearch: trackingSearchSchema,
  component: TrackingRoute,
});
function TrackingRoute() {
  const params = Route.useSearch();
  const navigate = useNavigate({ from: '/dispatch' });
  return (
    <DispatchPage
      params={params}
      onParamsChange={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })
      }
    />
  );
}
